import { action } from 'typesafe-actions';
import { EventTypesTypes, IEventType } from './types';

export const getUniEventTypesRecords = () => {
  return action(EventTypesTypes.GET_UNI_EVENT_TYPES);
};
export const getUniEventTypesRecordsSuccess = (eventTypes: IEventType[]) =>
  action(EventTypesTypes.GET_UNI_EVENT_TYPES_SUCCESS, eventTypes);
export const getUniEventTypesRecordsFailure = (error: string) =>
  action(EventTypesTypes.GET_UNI_EVENT_TYPES_FAILURE, error);
